import React from 'react';
import {Typography} from '@mui/material';
import {typografNode} from '../../utils/typograf';
import {COLORS} from '../../../../../config/constants';

function SequenceNumber({children, className}: {children: React.ReactNode; className?: string}) {
    return (
        <Typography className={className} sx={{
            fontFamily: 'Source Code Pro',
            fontWeight: 900,
            fontSize: '48px',
            lineHeight: 1,
            letterSpacing: 0,
            color: COLORS.GRAY_BLUE,
            '@media screen and (min-width: 768px)': {
                fontSize: '56px',
            },
            '@media screen and (min-width: 1200px)': {
                fontSize: '64px',
            },
        }}>{typografNode(children)}</Typography>
    );
}

export default SequenceNumber;
